module.exports = __webpack_public_path__ + "static/media/tilda_3.edeb1f68.jpg";